import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Input,
  OnInit,
} from '@angular/core';
import { map, nth, reduce, sum, toNumber } from 'lodash';

@Component({
    selector: 'lockton-apps-dynamic-form-calc-table-cell',
    templateUrl: './dynamic-form-calc-table-cell.component.html',
    styleUrls: ['./dynamic-form-calc-table-cell.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class DynamicFormCalcTableCellComponent implements OnInit {
  @Input() decimalFormat: string = '1.2';
  @Input() cellLabel: string = '';
  @Input() cellValue: any | undefined;
  @Input() headers: string[] = [];
  @Input() rows: { label: string; fields: string[] }[] = [];
  @HostBinding('style.--columns')
  public get gridTemplateColumns() {
    return this.headers.length + 1;
  }

  @Input() summary?: {
    label: string;
    operator: string;
    addonLeft: string[];
    decimalFormat: string;
  };

  totals: number[] = [];

  ngOnInit(): void {
    this.calculateTotals();
  }

  private calculateTotals() {
    if (this.cellValue) {
      const rows = map(this.rows, (row) => row.fields);
      const columnValues = map(this.headers, (_, index) =>
        map(rows, (rowFields) => {
          const rowField = nth(rowFields, index);
          return rowField ? toNumber(this.cellValue[rowField]) : 0;
        })
      );
      this.totals =
        this.summary?.operator === '*'
          ? map(
              columnValues,
              (valuesArray) => reduce(valuesArray, (a, b) => a * b) ?? 0
            )
          : map(columnValues, (valuesArray) => sum(valuesArray));
    }
  }
}
